import styled from 'styled-components';
import { colors } from '@/styles';

// https://cssloaders.github.io

export const ProcessingIcon = styled.div`
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
  background-color: pink;
  border-radius: 50%;

  &::after,
  &::before {
    content: '';
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid red;
    position: absolute;
    /* background-color: pink; */
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
    opacity: 0;
  }

  &::after {
    animation-delay: 1s;
  }

  @keyframes animloader {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;

export type TProcessingType = 'positive' | 'negative' | 'information' | 'notice';

export const ProcessingIcon2 = styled.div<{ type: TProcessingType }>`
  width: 16px;
  height: 16px;
  display: inline-block;
  position: relative;

  &::after,
  &::before {
    content: '';
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: ${({ type }) => colors.semantic[type].primary};
    position: absolute;
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
    opacity: 0;
  }
  &::after {
    animation-delay: 1s;
  }

  @keyframes animloader {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;
